import { getApolloContext, useQuery } from "@apollo/client"
import { useContext } from "react"
import { useSelector } from "react-redux"

import { GET_BUSINESS_SETTINGS } from "Shared/graphql/queries/getBusinessSettings"
import { selectLangageID } from "Shared/session"
import { datePatternForLanguage, setActiveDatePattern } from "Shared/utils/dateDisplayFormat"
import { getDateLocaleConfig } from "Utils/dateLocaleConfig"

const useTenantDatePatternFromApollo = (): string | undefined => {
  const accessToken = useSelector((state: { login?: { jwt?: string } }) => state?.login?.jwt)
  const langageId = useSelector(selectLangageID)
  const { data } = useQuery(GET_BUSINESS_SETTINGS, {
    fetchPolicy: "cache-first",
    skip: !accessToken,
  })
  return datePatternForLanguage(
    data?.getBusinessSettings?.dateFormats,
    getDateLocaleConfig(langageId).base
  )
}

/**
 * Pose le format de date de la langue courante (réglage tenant, RTB-171) dans l'état de module lu
 * par `formatDateForDisplay` et le DatePicker. Appelé PENDANT le rendu de `BusinessThemeProvider`,
 * pas dans un effet : ses enfants, rendus après lui, lisent déjà la bonne valeur.
 *
 * Hors `ApolloProvider` (tests de composants isolés) : aucun format imposé.
 */
export const useTenantDatePattern = (): string | undefined => {
  const { client } = useContext(getApolloContext())
  // La présence du client est stable pour toute la vie du composant (cf. useBusinessFormStyle).
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const pattern = client ? useTenantDatePatternFromApollo() : undefined
  setActiveDatePattern(pattern)
  return pattern
}
